import { Field } from 'formik';
import React from 'react';
import CustomRadio from '../../../../common/ui/CustomRadio';
import CustomInputWithIcon from '../../../../common/ui/CustomInputWithIcon';
import CustomSelect from '../../../../common/formElements/CustomSelect';

const DateExtraSetting = () => {
  return (
    <>
      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pt-3 text-center">
        <div className="form-check">
          <CustomRadio label="Only Date values" isRadio={true}>
            <Field
              className="form-check-input"
              type="radio"
              name="extraFieldSetting.dateDisplayType"
              value="date"
              id="exampleRadios1"
            />
          </CustomRadio>
          &nbsp;
          <CustomRadio label="Date along with Time" isRadio={true}>
            <Field
              className="form-check-input"
              type="radio"
              name="extraFieldSetting.dateDisplayType"
              value="datetime-local"
              id="exampleRadios1"
            />
          </CustomRadio>
          &nbsp;
          <CustomRadio label="Day/Month/Year Dropdowns" isRadio={true}>
            <Field
              className="form-check-input"
              type="radio"
              name="extraFieldSetting.dateDisplayType"
              value="date-segregated"
              id="exampleRadios1"
            />
          </CustomRadio>
        </div>
      </div>
      <Field name="extraFieldSetting.dateDisplayType">
        {({ field }) =>
          field.value === 'datetime-local' ? (
            <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
              <CustomInputWithIcon icon="select" extraCss="bmd-form-group">
                <Field name="extraFieldSetting.timeDisplayType">
                  {({ field, form, meta }) => (
                    <>
                      <CustomSelect
                        name={field.name}
                        value={field.value}
                        options={[
                          {
                            label: '12 Hour',
                            value: '12_HOURS',
                          },
                          {
                            label: '24 Hour',
                            value: '24_HOURS',
                          },
                        ]}
                        placeholder="Time Format (Default: 24 Hour)"
                        onChange={(name, value) => form.setFieldValue(name, value)}
                      />
                      {meta.touched && meta.error && <p className="errors">{meta.error}</p>}
                    </>
                  )}
                </Field>
              </CustomInputWithIcon>
            </div>
          ) : null
        }
      </Field>
    </>
  );
};

export default DateExtraSetting;
